import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/PolicyPages.css";

const PrivacyPolicy = () => {
  return (
    <>
      <Header />

      <div className="policy-hero">
        <h1>Privacy Policy</h1>
        <p>
          Learn how Ranthambore Tours & Travel Assistance collects, uses, and
          protects your personal information when you use our services.
        </p>
      </div>

      <div className="policy-wrapper">

        {/* INTRO */}
        <div className="policy-section">
          <h2>Introduction</h2>
          <p>
            Ranthambore Tours & Travel Assistance is a registered MSME enterprise
            based in Gurgaon, Haryana. We respect the privacy of our visitors and
            are committed to protecting personal information shared with us.
          </p>

          <p>
            This policy explains how we collect, use, and safeguard your information
            when you interact with our website or contact us for travel planning
            and assistance services.
          </p>
        </div>

        {/* DATA COLLECTION */}
        <div className="policy-section">
          <h2>Information We Collect</h2>

          <p>
            When you contact us or submit a travel enquiry, we may collect the
            following information:
          </p>

          <ul>
            <li>Name</li>
            <li>Phone number</li>
            <li>Email address</li>
            <li>Preferred travel dates</li>
            <li>Number of travelers</li>
            <li>Travel preferences related to safari experiences</li>
          </ul>

          <p>
            This information is collected only to assist in planning your
            Ranthambore trip and providing relevant travel support.
          </p>
        </div>

        {/* USAGE */}
        <div className="policy-section">
          <h2>How We Use Your Information</h2>

          <ul>
            <li>To assist with travel planning and tour package suggestions</li>
            <li>To communicate updates regarding your enquiry</li>
            <li>To provide customer support</li>
            <li>To improve our services and user experience</li>
            <li>To respond to customer inquiries</li>
          </ul>
        </div>

        {/* SECURITY */}
        <div className="policy-section">
          <h2>Information Protection</h2>

          <p>
            We take reasonable steps to ensure that your personal information is
            handled securely. We do not sell or misuse customer data.
          </p>

          <p>
            Access to personal information is limited only to individuals who
            require it for providing travel assistance services.
          </p>
        </div>

        {/* SHARING */}
        <div className="policy-section">
          <h2>Sharing of Information</h2>

          <p>
            We may share limited information with authorised operators or service
            providers only as required to coordinate travel components such as
            safari experiences.
          </p>

          <p>
            We do not share your information with third parties for marketing or
            unrelated purposes.
          </p>
        </div>

        {/* THIRD PARTY */}
        <div className="policy-section">
          <h2>Third-Party Services</h2>

          <p>
            Safari experiences are conducted by authorised operators under
            Ranthambore National Park regulations. We act as a travel assistance
            service and do not operate safari vehicles or issue permits directly.
          </p>
        </div>

        {/* CONTACT */}
        <div className="policy-section">
          <h2>Contact Information</h2>

          <p>
            <strong>Business Name (Registered):</strong> Ranthambore Safari Booking Assistance <br />
            <strong>Operating As:</strong> Ranthambore Tours & Travel Assistance <br />
            <strong>Location:</strong> Gurgaon, Haryana, India <br />
            <strong>Email:</strong> support@safariranthamborebooking.com <br />
            <strong>Phone:</strong> +91-9217691062
          </p>
        </div>

      </div>
x
      
    </>
  );
};

export default PrivacyPolicy;